export default "__VITE_ASSET__vsbjlpOp__"